<template lang="pug">
md-layout(md-flex='100')
  .md-headline {{ title }}
  // Name
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.name.$invalid }')
    label Name
    md-input#input-name(v-model='entity.name', :maxlength='200')
    span.md-error(v-if='formSubmitted && !validations.name.required') This field is required
    span.md-error(v-if='formSubmitted && validations.name.required && !validations.name.isUnique && !validations.name.$pending') Must be unique
  //Short description
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.shortDescription.$invalid }')
    label Short Description
    md-input#input-short-description(v-model='entity.shortDescription', :maxlength='200')
    span.md-error(v-if='formSubmitted && !validations.shortDescription.required') This field is required
  // Description
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.description.$invalid }')
    label Long Description
    md-textarea#input-long-description(v-model='entity.description', :maxlength='500')
    span.md-error(v-if='formSubmitted && !validations.description.required') This field is required
  // Tags
  md-chips#input-chips(v-model='entity.tags', :md-max='15', md-input-placeholder='Tags...')
    template(slot-scope='chip')
      span {{ chip.value }}
</template>

<script>
  export default {
    computed: {
    },
    methods: {
    },
    props: {
      editMode: {
        type: Boolean,
        default: false
      },
      canEditAccount: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Metadata'
      },
      entity: {
        type: Object,
        required: true
      },
      formSubmitted: {
        type: Boolean,
        required: true
      },
      validations: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-controls {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/MetadataForm.vue